"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = exports.AppMessages = void 0;
const en_json_1 = __importDefault(require("./data/en.json"));
const pl_json_1 = __importDefault(require("./data/pl.json"));
const AppLocale_enum_1 = require("../../context/locale/AppLocale.enum");
const keysToValues = (source) => {
    return Object.keys(source).reduce((accumulated, current) => {
        accumulated[current] = current;
        return accumulated;
    }, {});
};
exports.AppMessages = {
    ...keysToValues(en_json_1.default),
    ...keysToValues(pl_json_1.default),
};
exports.translations = {
    [AppLocale_enum_1.AppLocale.en]: en_json_1.default,
    [AppLocale_enum_1.AppLocale.pl]: pl_json_1.default,
};
